/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Portal_ScannerInputs */

const en_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const de_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal-Scanner`)
};

const fr_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const es_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const it_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const nl_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const pl_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const fi_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const da_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const sv_nav_portal_scanner = /** @type {(inputs: Nav_Portal_ScannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

/**
* | output |
* | --- |
* | "Portal Scanner" |
*
* @param {Nav_Portal_ScannerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_portal_scanner = /** @type {((inputs?: Nav_Portal_ScannerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Portal_ScannerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_portal_scanner(inputs)
	if (locale === "fr") return fr_nav_portal_scanner(inputs)
	if (locale === "es") return es_nav_portal_scanner(inputs)
	if (locale === "it") return it_nav_portal_scanner(inputs)
	if (locale === "nl") return nl_nav_portal_scanner(inputs)
	if (locale === "pl") return pl_nav_portal_scanner(inputs)
	if (locale === "fi") return fi_nav_portal_scanner(inputs)
	if (locale === "da") return da_nav_portal_scanner(inputs)
	if (locale === "sv") return sv_nav_portal_scanner(inputs)
	return en_nav_portal_scanner(inputs)
});